import React from "react";
import styled from "styled-components";

//import Arrow from 'src/assets/images/careers/Arrow.png'
//import { benefits } from 'src/data/career/listLocation'
import benefits from "src/assets/images/NewScene/benefit.png";

const Wrapper = styled.section`
padding: 8% 3% 8% 3%;
`;

const Title = styled.h1`
  color: black;
  text-align: center;
  font-weight: 700;
  font-size: 24px;
`;

const Text = styled.p`
  color: black;
  font-size: 16px;
  text-align: center;
`;

const Round = styled.div`
  background-color: white;
  max-width: 1000px;
  margin: 0 auto;
  border-radius: 20px;
  box-shadow: 3px 6px 56px 0px #2196f34f;
  @media screen and (max-width: 768px) {
    padding-top: 50px;
  }
  @media screen and (max-width: 500px) {
    padding-top: 20px;
  }
`;

// const Content = styled.div`
//   text-align: center;
//   padding: 20px 100px 40px 100px;
//   .border-none {
//     border: none !important;
//   }
//   @media screen and (max-width: 768px) {
//     padding: 0;
//   }
//   @media screen and (max-width: 500px) {
//     padding: 20px 20px 40px 20px;
//   }
// `

// const Contain = styled.div`
//   border-bottom: 1px dashed #cfc3c3;
//   padding-bottom: 20px;
//   width: 50%;
//   margin: 0 auto;
//   @media screen and (min-width: 1400px) {
//     width: 40%;
//   }
// `

// const ArrowImg = styled.img`
//   cursor: pointer;
//   padding-bottom: 30px;
//   @media screen and (max-width: 768px) {
//     padding-bottom: 100px;
//   }
//   @media screen and (max-width: 500px) {
//     padding-bottom: 30px;
//   }
//`



const Benefits: React.FC = () => {
  return (
    <Wrapper>
      <div>
        <img src={benefits} style={{width:'100%'}}>
        </img>
        {/* <Title>Benefits and Perks</Title>
        <Text>People are our greatest asset</Text>
        <Round>
          <Content>
            {benefits.map((v, i) => {
              return (
                <Contain key={i} className={`${i === 3 && 'border-none'}`}>
                  <Title>{v.title}</Title>
                  <Text>{v.description}</Text>
                </Contain>
              )
            })}
            <ArrowImg src={Arrow} alt='' width={50} />
          </Content>
        </Round> */}
      </div>
    </Wrapper>
  );
};

export default Benefits;
